import { ApplicationStatus } from '@efacity/common';

export const allowedStatusesToApprove = [
  ApplicationStatus.Submitted,
  ApplicationStatus.UnderReview,
  ApplicationStatus.ChangesRequested
];
export const allowedStatusesToRequestChanges = [ApplicationStatus.Submitted, ApplicationStatus.UnderReview];
